<template>
    <div>
    <card-dashboard 
        id="card-empresas-cadastradas"
        bg-variante="info" 
        titulo="" 
        :valor="valor"
        titulo-modal="Empresas cadastrados"
        :colunas="colunas"
        :dados="dados"
    >
        <template #titulo>
            <span>
                Empresas<br/>cadastradas
            </span>
        </template>
    </card-dashboard>
    </div>
</template>
<script>
import CardDashboard from "@/components/card/CardDashboard";
import DashboardAdminService from "@/common/services/dashboards/dashboard_admin.service";
export default {
    components : {
        CardDashboard
    },
    mounted(){
        this.buscarDados();
    },
    data : () => ({
        valor : 0,
        colunas : [
            { key : "text", label : "Empresa"}
        ],
        dados : [],
    }),
    methods : {
        buscarDados(){
            DashboardAdminService.empresasCadastradas().then(response => {
                this.dados = response.data.data.map(el => {
                    return {
                        text : el
                    }
                });
                this.valor = response.data.data.length;
            });
        }
    }
    
}
</script>
<style lang="">
    
</style>